/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Servicebusconnectionstring3Inputs */

const en_entity_servicebusconnectionstring3 = /** @type {(inputs: Entity_Servicebusconnectionstring3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Service Bus Connection String`)
};

const de_entity_servicebusconnectionstring3 = /** @type {(inputs: Entity_Servicebusconnectionstring3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Service Bus Verbindungszeichenfolge`)
};

/**
* | output |
* | --- |
* | "Service Bus Connection String" |
*
* @param {Entity_Servicebusconnectionstring3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_servicebusconnectionstring3 = /** @type {((inputs?: Entity_Servicebusconnectionstring3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Servicebusconnectionstring3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_servicebusconnectionstring3(inputs)
	return de_entity_servicebusconnectionstring3(inputs)
});
export { entity_servicebusconnectionstring3 as "entity_serviceBusConnectionString" }